// セレクトボックスの作成
const createSelectBox = (selectObj, inputSelectItem) => {
    const selectBox = document.createElement('div');
    selectBox.classList.add('c-forms-input-select__select-box');
    const selectBoxList = document.createElement('ul');
    selectBox.appendChild(selectBoxList);

    let focusFlg = true;
    const options = selectObj.options;
    for (let i = 0; i < options.length; i++) {
        const option = options[i];
        const optionItem = document.createElement('li');
        optionItem.textContent = option.textContent;
        optionItem.dataset.value = option.value;
        optionItem.dataset.index = i;
        optionItem.tabIndex = 0;
        if (selectObj.selectedIndex == i) {
            optionItem.dataset.selected = true;
        }
        optionItem.addEventListener('blur', (e) => {
            focusFlg = false;
            setTimeout(() => {
                if (focusFlg) return;
                inputSelectItem.dataset.open = false;
            }, 200);
        });
        optionItem.addEventListener('focus', (e) => {
            focusFlg = true;
        });

        selectBoxList.appendChild(optionItem);
    }

    selectBoxList.querySelectorAll('li').forEach(_obj => {
        _obj.addEventListener('click', (e) => {
            e.stopPropagation();
            selectBoxList.querySelector('[data-selected="true"]').removeAttribute('data-selected');
            const target = e.target;
            target.dataset.selected = true;
            const index = target.dataset.index;
            selectObj.selectedIndex = index;
            selectObj.dispatchEvent(new Event('change'));

            const mainObj = selectObj.closest('[data-select-block]');
            mainObj.querySelector('[data-select-value]').textContent = target.textContent;
            if (!target.dataset.value) {
                mainObj.querySelector('[data-select-value]').dataset.blank = true;
            } else {
                mainObj.querySelector('[data-select-value]').dataset.blank = false;
            }
            mainObj.dataset.open = false;
        });
    });

    return selectBox;
}

/*
const renderSelectedText = (selectObj) => {
    const selectedOption = selectObj.options[selectObj.selectedIndex];

    target.querySelector('.c-forms-input-select__value').textContent = selectedOption.textContent;
    if (!target.value) {
        inputSelectItem.querySelector('.c-forms-input-select__value').classList.add('.is-blank');
    }
}
*/

// フォーカス移動
const setFocusMoveByKeyboard = (inputSelectItem) => {
    inputSelectItem.addEventListener('keydown', function (event) {
        let target = event.target;
        let next = null;
        // 矢印キーの判定
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            next = target.nextElementSibling;
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            next = target.previousElementSibling;
        } else if (event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            target.click();
        } else if (event.key === 'Tab') {
            inputSelectItem.dataset.open = false;
        }

        // フォーカスを移動
        if (next && next.tagName === 'LI') {
            next.focus();
            event.preventDefault();
        }
        if (event.key === 'Escape') {
            target.closest('[data-select-block]').dataset.open = false;
        }
        if (event.key === 'Enter') {
            target.click();
        }
    });
}

// セレクトボックスの設定
export const setSelectAction = (inputSelectItem) => {
    const selectObj = inputSelectItem.querySelector('select');
    const selectedOption = selectObj.options[selectObj.selectedIndex];
    const selectedText = selectedOption.textContent;

    inputSelectItem.querySelector('[data-select-value]').textContent = selectedText;
    if (!selectedOption.value) {
        inputSelectItem.querySelector('[data-select-value]').dataset.blank = true;
    }

    // readonly属性がある場合は処理をしない
    if (selectObj.hasAttribute('readonly')) return;


    const selectBox = createSelectBox(selectObj, inputSelectItem);
    inputSelectItem.querySelector('[data-select-input]').appendChild(selectBox);
    inputSelectItem.addEventListener('click', (e) => {
        const target = e.currentTarget;
        const rect = inputSelectItem.getBoundingClientRect();
        target.querySelector('select').focus();
        if (rect.top + rect.height / 2 > window.innerHeight / 2) {
            selectBox.dataset.position = 'top';
        } else {
            selectBox.removeAttribute('data-position');
        }
        const open = inputSelectItem.dataset.open === 'true';
        inputSelectItem.dataset.open = !open;
        if (inputSelectItem.dataset.open) { // 開いたとき
            // 選択済の要素にフォーカスを移動
            selectBox.querySelector(`[data-index="${selectObj.selectedIndex}"]`).focus();
        }
    });
    setFocusMoveByKeyboard(inputSelectItem);
}

const main = () => {
    if (document.querySelector('.c-forms-input-select') == null) return;
    const inputSelectItems = document.querySelectorAll('.c-forms-input-select [data-select-block]');

    inputSelectItems.forEach((inputSelectItem) => {
        setSelectAction(inputSelectItem);
    });
}

export default main;
